import React from "react"

const FeatureCross = ({ children, className = "" }) => {
  return <li className={`feature-cross ${className}`}>{children}</li>
}

export default FeatureCross
